export const ADMIN = "ADMIN";
export const CS = "CS";
export const SUPERADMIN = "SUPERADMIN"
export const FINANCEADMIN = "FINANCEADMIN";
export const PARTNER = "PARTNER";
